import { render, staticRenderFns } from "./Project12.vue?vue&type=template&id=d4d65e60&scoped=true&"
import script from "./Project12.vue?vue&type=script&lang=js&"
export * from "./Project12.vue?vue&type=script&lang=js&"
import style0 from "./Project12.vue?vue&type=style&index=0&id=d4d65e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d65e60",
  null
  
)

export default component.exports